import { LoaderFunctionArgs } from 'react-router-dom'
import { getFloatingMessages } from '../../action/floating-messages'

export const floatingMessagesLoader = async ( args: LoaderFunctionArgs ) => {

    await getFloatingMessages( )

}
